import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const SocialTwitterIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { d: "M13.6754 10.8068L20.2322 3.18506H18.6784L12.9852 9.80294L8.43799 3.18506H3.19336L10.0696 13.1925L3.19336 21.1851H4.74719L10.7594 14.1964L15.5616 21.1851H20.8062L13.675 10.8068H13.6754ZM11.5472 13.2806L10.8505 12.2841L5.30706 4.35477H7.69366L12.1673 10.754L12.864 11.7505L18.6792 20.0685H16.2926L11.5472 13.281V13.2806Z", fill: "currentColor" }));
//# sourceMappingURL=SocialTwitterIcon.js.map